import new_player_set_events from "@/components/player-no-blob/modules/new_player_set_events";

const createSource = (url, type) => {
    let source = document.createElement('source')
    source.setAttribute('type', type)
    source.setAttribute('src', url)

    return source
}

export default async (context) => {
    let button = document.getElementById('player-component__button')
    button.style.display = 'none'
    context.is_ready_play = false
    let component = document.getElementById('player-component').children[0]
    let video = document.createElement('video')
    video.setAttribute('id', `player-component__video`)

    let sourceMP4 = createSource(context.videos[0].video, 'video/mp4')
    let sourceWebm = createSource(context.videos[0].webm, 'video/webm')

    video.setAttribute('muted', 'muted')
    video.setAttribute('playsinline', '');
    video.setAttribute('controlslist', 'nodownload');

    video.append(sourceWebm)
    video.append(sourceMP4)

    component.append(video)

    video.load()

    new_player_set_events(context, video)
    context.$emit('loadingComplete')
}